import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Platform } from 'ionic-angular';

/** Google Play listing for מנטסנט */
export const PLAY_STORE_LISTING =
  'https://play.google.com/store/apps/details?id=com.matnasnet.matnasnet';

/** App Store — `action=write-review` opens the review composer when supported */
export const APP_STORE_WRITE_REVIEW =
  'https://apps.apple.com/app/id1542235552?action=write-review';

export function getStoreRateLabel(platform: Platform): string {
  if (platform.is('ios')) {
    return 'App Store';
  }
  if (platform.is('android')) {
    return 'Google Play';
  }
  return 'App Store';
}

export function getStoreRateUrl(platform: Platform): string | null {
  if (platform.is('ios')) {
    return APP_STORE_WRITE_REVIEW;
  }
  if (platform.is('android')) {
    return PLAY_STORE_LISTING;
  }
  return null;
}

export function openAppStoreRating(iab: InAppBrowser, platform: Platform): void {
  const url = getStoreRateUrl(platform);
  if (url) {
    iab.create(url, '_system');
  }
}



// WEBPACK FOOTER //
// ./src/services/store-rate.ts